import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// import './plugins/element.js'
Vue.use(ElementUI);
// 导入全局样式
import '../src/assets/css/global.css'
// 导入字体图标
import '../src/assets/css/iconfont.css'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
